/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  DashboardFilters,
  DashboardFilters$Outbound,
  DashboardFilters$outboundSchema,
} from "./dashboardfilters.js";

export type SaveDashboardFiltersRequestBody = {
  /**
   * What a dashboard opens on: its date range and the values picked for each catalog dimension its filter bar offers. Changes in the bar are a personal view until they are saved here.
   */
  filters: DashboardFilters;
  /**
   * The dashboard to save filters on
   */
  id: string;
};

/** @internal */
export type SaveDashboardFiltersRequestBody$Outbound = {
  filters: DashboardFilters$Outbound;
  id: string;
};

/** @internal */
export const SaveDashboardFiltersRequestBody$outboundSchema: z.ZodMiniType<
  SaveDashboardFiltersRequestBody$Outbound,
  SaveDashboardFiltersRequestBody
> = z.object({
  filters: DashboardFilters$outboundSchema,
  id: z.string(),
});

export function saveDashboardFiltersRequestBodyToJSON(
  saveDashboardFiltersRequestBody: SaveDashboardFiltersRequestBody,
): string {
  return JSON.stringify(
    SaveDashboardFiltersRequestBody$outboundSchema.parse(
      saveDashboardFiltersRequestBody,
    ),
  );
}
